module.exports = __webpack_public_path__ + "img/icon_arrow_right.c437085b.svg";